// this file added for individual by Bearer Web Developer
import { flow, getEnv, getParentOfType, Instance, types } from "mobx-state-tree";
import { TCreateNewCustomerRequest, TCreateNewCustomerResponse } from "./models/createNewCustomer";
import { firebaseApp } from "../../api/bearer-api";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getMessaging, getToken, isSupported } from "firebase/messaging";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { AppState, EnvType, IAppState, MessageEnum } from "../app-state";
import { getPublicip } from "../../app/getPublicip";
import { ISigninState } from "../signinState";
export type TGender = "Male" | "Female" | 'None-binary' | "Prefer not to say" | '';
type TitleMethod = "Social Media Ads" | "Phone Calls" | "Shopify App Store" | "Other" |
    "Email & Newsletters" | "Search Engine" | "Referral Code" | "Flyers (Public Campaigns)"
export interface InviteMethod {
    title: TitleMethod
    src: string
    id: number
}
export const NewCustomerState = types
    .model("NewCustomerState", {
        given_name: types.optional(types.string, ''),
        last_name: types.optional(types.string, ''),
        email_address: types.optional(types.string, ''),
        avatar_url: types.optional(types.string, ''),
        birth_date: types.optional(types.string, ''),
        gender: types.optional(types.frozen<TGender>(), ''),
        referred_by: types.optional(types.string, ''),
        inviteCode: types.optional(types.string, ""),
        inviteMethod: types.maybeNull(types.frozen<InviteMethod>()),
    }).views(self => ({
        get referredBy() {
            return self?.inviteMethod?.title === "Referral Code" ? self?.inviteCode : self?.inviteMethod?.title;
        }
    }))
    .actions(self => {
        return {
            clear() {
            },
            setAvatarUrl(avatar_url: string) {
                self.avatar_url = avatar_url;
            },
            setGivenName(value: string) {
                self.given_name = value;
            },
            setLastName(value: string) {
                self.last_name = value;
            },
            setEmail(value: string) {
                self.email_address = value;
            },
            setGender(value: TGender) {
                self.gender = value;
            },
            setBirthDate(birth_date: string) {
                self.birth_date = birth_date;
            },
            setReferred_by(value: string) {
                self.referred_by = value;
            },
            setActiveInviteMethod(value: InviteMethod | null) {
                self.inviteMethod = value;
            },
            setInviteCode(value: string) {
                self.inviteCode = value;
            },
            createNewCustomer: async (data: TCreateNewCustomerRequest) => {
                const functions = getFunctions(firebaseApp, 'australia-southeast2');
                const t = httpsCallable<TCreateNewCustomerRequest, TCreateNewCustomerResponse>(functions, 'createNewCustomerSecondGen');
                const result = await t(data);
                return result.data;
            },
        }
    }).actions(self => {
        return {
            signupNewCustomer: async () => {
                // get fcm_token, unique_device_id start
                const supported = await isSupported();
                console.log({ supported });
                let fcm_token = '';
                let unique_device_id = '';
                if (supported) {
                    const messaging = getMessaging(firebaseApp);
                    const token = await getToken(messaging, { vapidKey: process.env.REACT_APP_VapIdKey });
                    fcm_token = token || '';
                    const fpPromise = FingerprintJS.load();
                    const fp = await fpPromise
                    const key = await fp.get()
                    unique_device_id = key.visitorId;
                }
                // get fcm_token, unique_device_id end
                const api = getEnv<EnvType>(self).api;
                const appState = getEnv<EnvType>(self).api.appState!;
                const mobileNumber = appState?.login.mobileNumber;
                const latest_tc_pp_vers_signed = api.bearerWebAppRemoteConfigParameters()?.version || '';
                const ip = await getPublicip();
                if (!ip) {
                    console.log({ ip });
                    console.error('something went wrong in getting ip');
                    return;
                }
                const data: TCreateNewCustomerRequest = {
                    fcm_token, unique_device_id, latest_tc_pp_vers_signed,
                    latest_tc_pp_vers_sign_ip: ip, platform_type: 'web_ic',
                    mobile_number: `+61${mobileNumber}`, given_name: self.given_name,
                    last_name: self.last_name, email_address: self.email_address,
                    avatar_url: self.avatar_url, birth_date: self.birth_date,
                    gender: self.gender,
                    referred_by: self?.referredBy?.toUpperCase() || "Early Adopter",
                }
                console.log({ createNewCustomerData: data });
                const result = await self.createNewCustomer(data);
                if (result.code === 200) {
                    return result;
                } else if (result.code === 499) {
                    appState.setErrorMessage({
                        message: result.message || 'unknown error!',
                        error: MessageEnum.Unknown,
                    });
                } else if (result.code === 401) {
                    appState.setErrorMessage({
                        message: result.message || 'unknown error!', error: MessageEnum.Error401,
                    });
                } else if (result.code === 500) {
                    appState.setErrorMessage({
                        message: result.message || 'unknown error!', error: MessageEnum.ServerError,
                    });
                }
                return false;
            },
            deleteProfileImage: flow(function* () {
                const api = getEnv<EnvType>(self).api;

                ///// To solve AppCheck - WebApp Issue on Loading App State and Tabs if any
                api.callApiWithAppCheck();

                try {
                    if (!api?.appState?.signin.uid) return;
                    const signin: ISigninState = getParentOfType(self, AppState).signin;
                    yield api.deleteProfileImage(signin?.uid || '');
                    self.avatar_url = "";

                } catch (err: any) {
                    const appState = getParentOfType(self, AppState);
                    appState.setErrorMessage({
                        message: err?.message || 'unknown error!',
                        error: MessageEnum.Unknown
                    })
                }
            }),
            updateAvatar: flow(function* (image: Blob) {
                const api = getEnv<EnvType>(self).api;

                ///// To solve AppCheck - WebApp Issue on Loading App State and Tabs if any
                api.callApiWithAppCheck();

                try {
                    const signin: ISigninState = getParentOfType(self, AppState).signin;
                    if (!signin.uid) return;
                    const result = yield api.uploadProfileImage(signin.uid, image);
                    self.avatar_url = result;
                } catch (err: any) {
                    const appState = getParentOfType(self, AppState);
                    appState.setErrorMessage({
                        message: err?.message || 'unknown error!',
                        error: MessageEnum.Unknown
                    })
                }
            }),
        }
    })
export interface INewCustomerState extends Instance<typeof NewCustomerState> { };

